import React, { useEffect, useRef, useState } from 'react';
import chat1 from '../../assets/chat1.jpg';
import chat2 from '../../assets/chat2.png';
import chat3 from '../../assets/chat3.jpg';
import './Chatbot-edvora.css';

const NextSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [typedText, setTypedText] = useState('');
  const [showCoachingCard, setShowCoachingCard] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % 3);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(slideInterval);
  }, []);

  const fullText = "Developed an intelligent chatbot fine-tuned on LLaMA 2 to deliver context-aware, human-like responses for student and faculty queries. By leveraging transfer learning and domain-specific datasets, the model improves accuracy, reduces hallucinations, and enhances conversational flow. This project streamlines campus communication, offering instant academic and administrative support while reducing workload for staff. With advanced NLP and deep learning techniques, it provides scalable, reliable, and interactive assistance for education and beyond.";

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.3,
        rootMargin: '-50px 0px'
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isVisible) {
      // Show coaching card immediately when section becomes visible
      setShowCoachingCard(true);

      let currentIndex = 0;
      const typeInterval = setInterval(() => {
        if (currentIndex <= fullText.length) {
          setTypedText(fullText.slice(0, currentIndex));
          currentIndex++;
        } else {
          clearInterval(typeInterval);
        }
      }, 50);

      return () => clearInterval(typeInterval);
    }
  }, [isVisible, fullText]);

  return (
    <section className="next-section" ref={sectionRef}>
      <div className="next-container">
        <div className={`next-header ${isVisible ? 'animate-up' : ''}`}>
          <p className="next-subtitle">EdVora-College Help-Desk Chatbot</p>
          <h2 className="next-title">Interactive chatbot providing instant answers to student and faculty queries, streamlining campus communication.</h2>
        </div>

        <div className="next-content">
          <div className="next-text-section">
            <div className={`persona-card reese-persona ${isVisible ? 'slide-in-left' : ''}`}>
              <div className="chatbot-logo-large">
                <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="#f97316" strokeWidth="2" />
                  <circle cx="12" cy="12" r="6" fill="#f97316" opacity="0.3" />
                  <path d="M8 10h8M8 14h6" stroke="#f97316" strokeWidth="1.5" strokeLinecap="round" />
                  <circle cx="15" cy="9" r="1.5" fill="#f97316" />
                  <circle cx="9" cy="15" r="1" fill="#f97316" />
                </svg>
              </div>
              <div className="chatbot-project-info">
                <h3>EdVora Chatbot</h3>
                <p>AI Student Assistant</p>
              </div>
            </div>

            <div className="next-text-container">
              <div className={`expanding-container ${typedText ? 'expanded' : ''}`}>
                <p className="typewriter-text">{typedText}</p>
                <span className="cursor">|</span>
              </div>

              {/* Resume Creation Container */}
              <div className={`chatbot-coaching-card ${showCoachingCard ? 'slide-up' : ''}`}>
                <div className="coaching-header">


                </div>

                {/* Image Slideshow Container - positioned above the feature points */}
                <div className="image-slideshow-container">
                  <div className="slideshow-wrapper">
                    <div className={`slide ${currentSlide === 0 ? 'active' : ''}`}>
                      <img src={chat1} alt="Chatbot Interface 1" className="slide-image" />
                    </div>
                    <div className={`slide ${currentSlide === 1 ? 'active' : ''}`}>
                      <img src={chat2} alt="Chatbot Interface 2" className="slide-image" />
                    </div>
                    <div className={`slide ${currentSlide === 2 ? 'active' : ''}`}>
                      <img src={chat3} alt="Chatbot Interface 3" className="slide-image" />
                    </div>
                  </div>
                  <div className="slide-dots">
                    <button
                      className={`dot ${currentSlide === 0 ? 'active' : ''}`}
                      onClick={() => setCurrentSlide(0)}
                    ></button>
                    <button
                      className={`dot ${currentSlide === 1 ? 'active' : ''}`}
                      onClick={() => setCurrentSlide(1)}
                    ></button>
                    <button
                      className={`dot ${currentSlide === 2 ? 'active' : ''}`}
                      onClick={() => setCurrentSlide(2)}
                    ></button>
                  </div>
                </div>

                <div className="coaching-features-combined">
                  <div className="feature-item">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#f97316" />
                    </svg>
                    <span>24/7 availability</span>
                  </div>
                  <div className="feature-item">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#f97316" />
                    </svg>
                    <span>Instant responses</span>
                  </div>
                  <div className="feature-item">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#f97316" />
                    </svg>
                    <span>Multi-language support</span>
                  </div>
                  <div className="feature-item">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="#f97316" />
                    </svg>
                    <span>Campus integration</span>
                  </div>
                </div>
              </div>

              <div className="github-btn-container">
                <a
                  href="https://github.com/Mujakathali/ChatBot-EdVora"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="github-btn"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                  </svg>
                  View on GitHub
                </a>
              </div>
            </div>
          </div>


        </div>
      </div>
    </section>
  );
};

export default NextSection;
